var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.34125 6.58754C1.56969 6.35974 1.94007 6.35974 2.16851 6.58754L4.50834 8.92087C4.73678 9.14868 4.73678 9.51803 4.50834 9.74583C4.2799 9.97364 3.90952 9.97364 3.68108 9.74583L1.34125 7.4125C1.11281 7.18469 1.11281 6.81535 1.34125 6.58754Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43598 7.17085C5.66442 6.94305 6.03479 6.94305 6.26323 7.17085L8.01811 8.92085C8.24655 9.14866 8.24655 9.51801 8.01811 9.74581C7.78967 9.97362 7.41929 9.97362 7.19085 9.74581L5.43598 7.99581C5.20754 7.76801 5.20754 7.39866 5.43598 7.17085Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18801 4.25417C9.41645 4.48197 9.41645 4.85132 9.18801 5.07913L4.50835 9.74579C4.27991 9.9736 3.90954 9.9736 3.6811 9.74579C3.45266 9.51799 3.45266 9.14864 3.6811 8.92083L8.36076 4.25417C8.5892 4.02636 8.95957 4.02636 9.18801 4.25417Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6978 4.25417C12.9262 4.48197 12.9262 4.85132 12.6978 5.07913L8.01812 9.74579C7.78968 9.9736 7.4193 9.9736 7.19086 9.74579C6.96242 9.51799 6.96242 9.14864 7.19086 8.92083L11.8705 4.25417C12.099 4.02636 12.4693 4.02636 12.6978 4.25417Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAll);
export default __webpack_public_path__ + "static/media/check-all.2dcc77930247a9516492f4feb9898f05.svg";
export { ForwardRef as ReactComponent };